import { ReadyRoomShell } from "@/components/vyllage/ReadyRoomShell";

/** Personal pod customization (not the live multiplayer HQ at /office). */
export function PodOfficePage() {
  return <ReadyRoomShell panel="office" />;
}
